const reconnectSessionOnService = async (url, requestOptions) => {
  const path = `${url}api/v1/sessions/reconnect`;
  // eslint-disable-next-line no-console
  const data =  await fetch(path, requestOptions).then(response => response.json()).catch(err => console.error(err));
  return data;
};

const restartSession = async (url, requestOptions) => {
  const path = `${url}restart`;
  try {
    const response = await fetch(path, requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.status;
  } catch (err) {
    console.error('Erro no restart da sessão:', err);
    return { error: err.message };
  }
}

export { reconnectSessionOnService, restartSession };
